<template>
  <div class="tasks">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-narrow is-mobile">
            <b-button v-if="(!is_template && currentUserAccess('TaskDetails', this.UserActions.CREATE, this.project_id))
                            || (is_template && currentUserAccess('ProjectTemplates', this.UserActions.CREATE))"
                      class="button is-primary" icon-left="plus-thick" @click="addNewTaskClicked">
              {{ $t('tasks-view.new-task-button') }}
            </b-button>
          </div>
          <div class="column is-narrow is-mobile">
            <b-button v-if="(!is_template && currentUserAccess('TaskDetails', this.UserActions.CREATE, this.project_id))
                            || (is_template && currentUserAccess('ProjectTemplates', this.UserActions.CREATE))"
                      class="button is-primary" icon-left="import" @click="importTasksClicked">
              {{ $t('tasks-view.import-task-button') }}
            </b-button>
          </div>
        </div>
        <div class="columns">
          <div class="column column is-full">
            <b-table class="tasks-table" :data="tasksData" :striped="true"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true">
              <b-table-column field="task.title" :label="this.$t('tasks-view.task-title-column')" v-slot="props"
                              width="16%" sortable searchable>
                <router-link
                    :to="{ name: 'TaskDetails', params: { project_id:project_id, task_id:props.row.task.document_id, is_template: is_template }}">
                  {{ getAdjustedTitle(props.row.task.title) }}
                </router-link>
              </b-table-column>
              <b-table-column field="task.category" :label="this.$t('tasks-view.task-category-column')" v-slot="props"
                              width="12%" sortable searchable>
                {{ props.row.task.category }}
              </b-table-column>
              <b-table-column field="quantity" :label="this.$t('tasks-view.task-quantity-column')" v-slot="props">
                {{ getFormattedQuantity(props.row.estimation, props.row.task.unit) }}
              </b-table-column>
              <b-table-column field="estimation.expected_fee_per_unit"
                              :label="this.$t('tasks-view.task-expected-fee-per-unit-column')" v-slot="props" sortable>
                {{ getFormattedPricing(props.row.estimation.expected_fee_per_unit) }}
              </b-table-column>
              <b-table-column field="estimation.expected_total_fee"
                              :label="this.$t('tasks-view.task-expected-total-fee-column')"
                              v-slot="props" sortable>
                {{ getFormattedPricing(props.row.estimation.expected_total_fee) }}
              </b-table-column>
              <b-table-column field="performance" :label="this.$t('tasks-view.task-performance-column')" v-slot="props">
                {{ getFormattedPerformance(props.row.estimation.performance, props.row.task.unit) }}
              </b-table-column>
              <b-table-column field="estimation.number_of_internal_personnel"
                              :label="this.$t('tasks-view.task-internal-personnel-number-column')" v-slot="props"
                              width="6%" sortable>
                {{ props.row.estimation.number_of_internal_personnel }}
              </b-table-column>
              <b-table-column field="estimation.number_of_external_personnel"
                              :label="this.$t('tasks-view.task-external-personnel-number-column')" v-slot="props"
                              width="6%" sortable>
                {{ props.row.estimation.number_of_external_personnel }}
              </b-table-column>
              <b-table-column field="estimation.expected_internal_hours"
                              :label="this.$t('tasks-view.task-expected-internal-hours-column')" v-slot="props"
                              sortable>
                {{ getFormattedTimeHour(props.row.estimation.expected_internal_hours) }}
              </b-table-column>
              <b-table-column field="estimation.expected_external_hours"
                              :label="this.$t('tasks-view.task-expected-external-hours-column')" v-slot="props"
                              sortable>
                {{ getFormattedTimeHour(props.row.estimation.expected_external_hours) }}
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isTaskDetailsModalActiveLocal"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <TaskDetails v-bind:project_id="project_id" v-bind:task_id="'new'" @close="props.close"
                       @taskAdded="readTasksData"></TaskDetails>
        </template>
      </b-modal>
      <b-modal
          :width="640"
          v-model="isImportFromFileModalActiveLocal"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <ImportFromFileDetails v-bind:project_id="project_id" @close="props.close"
                             @fileUploaded="onImportFileIsUploaded"></ImportFromFileDetails>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
import TaskDetails from "@/components/TaskDetails";
import firebase from "firebase/app";
import ImportFromFileDetails from "@/components/ImportFromFileDetails";

export default {
  name: "Tasks",
  components: {
    ImportFromFileDetails,
    TaskDetails
  },
  props: {
    'project_id': {
      type: String,
    },
    'is_template': {
      type: Boolean,
    }
  },
  data() {
    return {
      tasksData: [],
      isLoading: false,
      isTaskDetailsModalActiveLocal: false,
      isImportFromFileModalActiveLocal: false,
    }
  },
  methods: {
    readTasksData: function () {
      this.isTaskDetailsModalActiveLocal = false;
      this.isLoading = true;
      this.tasksData = [];
      const functions = firebase.app().functions("europe-west3");
      const getTasksFunction = functions.httpsCallable(this.getSubmitEndpoint());
      console.log("project_id: ", this.project_id);
      getTasksFunction({action: "get_tasks", project_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("task list result: ", result.data);
            if (result.data.tasks.length > 0) {
              result.data["tasks"].forEach((task) => {
                this.tasksData.push({
                  task: task,
                  estimation: task.meta.estimation ? task.meta.estimation : {}
                });
              });
            }
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting tasks: ", error);
          });
      this.isLoading = false;
    },
    onImportFileIsUploaded: function (filePath) {
      console.log("Uploaded file for import: ", filePath);
      this.isImportFromFileModalActiveLocal = false;
      this.isLoading = true;
      const functions = firebase.app().functions("europe-west3");
      const importBulkTasksFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const dataFields = {
        project_id: this.project_id,
        filename: filePath,
        action: "insert_bulk_tasks"
      }
      importBulkTasksFunction(dataFields)
          .then((result) => {
            this.showSuccess(this.$t("tasks-view.tasks-imported-successfully"))
            console.log("import bulk tasks result: ", result.data);
            this.readTasksData();
          })
          .catch((error) => {
            this.isLoading = false
            this.showError(error.message)
            console.log("import bulk tasks: ", error);
          });
    },
    /*
     UI Events
     */
    addNewTaskClicked: function () {
      this.isTaskDetailsModalActiveLocal = true;
    },
    importTasksClicked: function () {
      this.isImportFromFileModalActiveLocal = true;
    },
  },
  mounted() {
    this.readTasksData()
  }
};
</script>

<style scoped>
.tasks-table {
  margin-top: 16px;
}
</style>
